// Lib
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

// Utils
import { stopPropagationOnly } from '../../../utils/domUtil';
import { getElementId } from '../../../../common/elements/utils/elementPropertyUtils';
import { isLocationRootBoard } from '../../../../common/elements/utils/elementLocationUtils';

// Selectors
import { isEditableSelector } from '../../../workspace/workspaceSelector';
import { getElementFilterQuerySelector } from '../../../element/elementFilter/elementFilterSelector';

// Components
import MobileHeader from '../../structural/MobileHeader';
import MobileBoardHeaderBackButton from './MobileBoardHeaderBackButton';
import EditableTitle from '../../../components/editableTitle/EditableTitle';
import MobileHeaderRightSection from './MobileHeaderRightSection';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';
import { BreadcrumbResult } from '../../../workspace/breadcrumbs/breadcrumbUtil';
import { CURRENT_BOARD_HEADER_TITLE_EDITOR_KEY } from '../../../../common/boards/boardConstants';

// Styles
import './MobileBoardHeader.scss';

interface MobileBoardHeaderProps {
    currentBoard: ImMNElement;
    breadcrumbObj?: BreadcrumbResult;
}

const MobileBoardHeader = (props: MobileBoardHeaderProps): ReactElement => {
    const { currentBoard, breadcrumbObj } = props;

    const filterQuery = useSelector(getElementFilterQuerySelector);
    const isEditable = useSelector(isEditableSelector);

    // If we are on the root board:
    // - Don't render header content
    // - Still render whitespace in top safe area
    if (isLocationRootBoard(currentBoard)) {
        return <MobileHeader className="MobileBoardHeader" />;
    }

    const currentBoardId = getElementId(currentBoard);

    return (
        <MobileHeader className="MobileBoardHeader">
            <div className="left-section">
                <MobileBoardHeaderBackButton breadcrumbObj={breadcrumbObj} />
            </div>
            {/* Stop propagation to prevent clicks from causing the edit to
                immediately complete due to the MobileHeader click handler */}
            <div className="board-title" onClick={stopPropagationOnly}>
                <EditableTitle
                    selectAllOnEdit
                    filterQuery={filterQuery}
                    element={currentBoard}
                    elementId={currentBoardId}
                    isEditable={isEditable}
                    editorKey={CURRENT_BOARD_HEADER_TITLE_EDITOR_KEY}
                />
            </div>
            <MobileHeaderRightSection />
        </MobileHeader>
    );
};

export default MobileBoardHeader;
